import {useCallback} from 'react';
import {DownloadZipCard} from '../../../../shared/campaign/DownloadZipCard';
import {downloadSessionZip} from '../../services/agentSessionService';

export default function DownloadZipIntegration({
  sessionId = null,
  isReadOnly = false,
}) {
  const handleDownload = useCallback(async () => {
    if (!sessionId || isReadOnly) {
      return;
    }
    await downloadSessionZip(sessionId);
  }, [sessionId, isReadOnly]);

  return <DownloadZipCard onClick={handleDownload} />;
}
